export default __webpack_public_path__ + "static/media/secrets_openapi.c3831edd.yaml";